export const APPLICANT_DETAIL_REFRESH_MS = 10000;

export function shouldRefreshApplicantDetail(documentRef = globalThis.document) {
  return documentRef?.visibilityState !== 'hidden';
}
